import React from "react";

export default function TradingViewSignals({ type = "copy" }) {
  const getWidgetSrc = () => {
    switch (type) {
      case "copy":
        return "https://s.tradingview.com/widgetembed/?frameElementId=tradingview_copy_signals&symbol=FOREXCOM:EURUSD&interval=15&theme=dark&style=1&locale=en";
      case "community":
        return "https://s.tradingview.com/embed-widget-ideas/?locale=en#%7B%22colorTheme%22%3A%22dark%22%7D";
      case "premium":
        return null;
      default:
        return "https://s.tradingview.com/embed-widget-screener/?locale=en#%7B%22colorTheme%22%3A%22dark%22%7D";
    }
  };

  const src = getWidgetSrc();

  if (type === "premium") {
    return (
      <div className="flex items-center justify-center h-full text-slate-400 text-sm flex-col text-center">
        <p>🔒 Premium Signals Coming Soon</p>
        <p className="text-xs text-slate-500 mt-2">
          Available only for verified M2T Premium SmartCard members.
        </p>
      </div>
    );
  }

  return (
    <div className="w-full h-full bg-slate-950 overflow-hidden rounded-lg border border-slate-800">
      <iframe
        title={`TradingView ${type}`}
        src={src}
        width="100%"
        height="100%"
        
        frameBorder="0"
        loading="lazy"
        style={{
          border: "none",
          width: "100%",
          height: "100%",
        }}
      />
    </div>
  );
}
